import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../auth/auth.store';
import { AuthService } from '../auth/auth.service';

/**
 * Allow only authenticated users; otherwise redirect to /welcome.
 * Returning a UrlTree (router.parseUrl) makes the redirect part of the same
 * navigation, so the URL bar stays in sync.
 *
 * If the user's in-memory session is empty (e.g. direct URL entry or page refresh),
 * attempt a silent refresh via the HttpOnly cookie / stored refresh token before
 * bouncing to /welcome.
 */
export const authGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStore);
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authStore.isAuthenticated()) return true;

  const refreshed = await authService.refresh();
  if (refreshed && authStore.isAuthenticated()) {
    return true;
  }

  return router.parseUrl('/welcome');
};
